import isEmail from 'validator/lib/isEmail'

export const validateEmail = (email: string) => {
    return isEmail(email)
}
